/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React from "react";
import { NavFragment } from "../../../graphql-types";
import Nav from "./nav";

export type Nav2Props = NavFragment;
export const Nav2: React.FC<Nav2Props> = ({ navItems }) => {
  return (
    <Box bg="primary">
      <Flex
        variant="layout.box"
        sx={{ height: "2em", alignItems: "center" }}
      >
        <Nav variant="shop" navItems={navItems}></Nav>
      </Flex>
    </Box>
  );
};

export default Nav2;
